import React from "react";
// import React, { useEffect } from "react";

export default function TermsAndConditions() {
  //     useEffect(() => {
  //     window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  //   }, []);
  return (
    <main className="min-h-screen bg-gradient-to-b from-[#0f172a] via-[#111827] to-[#0b1220] text-slate-100">
      {/* Top Accent */}
      <div className="h-1 w-full bg-gradient-to-r from-sky-400 via-cyan-400 to-sky-500" />

      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-10">
        <header className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">
            Terms &amp; Conditions
          </h1>
          <p className="mt-2 text-slate-300">
            Last updated: <span className="font-medium">14 October 2025</span>
          </p>
          <p className="mt-1 text-slate-400">
            These Terms &amp; Conditions (“Terms”) govern your access to and use
            of <span className="text-sky-300">https://growmax.ogcs.co.in/</span>{" "}
            (the “Website”) and the training programs and services offered by
            OGCS Private Limited (“Growmax OGCS”, “we”, “us”, or “our”). By
            accessing or using the Website or enrolling in any program, you
            agree to be bound by these Terms.
          </p>
        </header>

        <div className="space-y-8">
          {/* 1 */}
          <section>
            <h2 className="text-xl font-bold text-white">1. About Us</h2>
            <p className="mt-2 text-slate-300">
              Growmax OGCS is operated by{" "}
              <span className="font-semibold">OGCS Private Limited</span>. We
              offer professional training and development programs, including
              technical, interview preparation, leadership, soft skills,
              construction, and safety courses across India.
            </p>
          </section>

          {/* 2 */}
          <section>
            <h2 className="text-xl font-bold text-white">
              2. Accounts &amp; Accuracy of Information
            </h2>
            <p className="mt-2 text-slate-300">
              When you register or book a program, you agree to provide current,
              complete, and accurate information. You are responsible for
              safeguarding your login credentials and all activities under your
              account.
            </p>
          </section>

          {/* 3 */}
          <section>
            <h2 className="text-xl font-bold text-white">
              3. Programs, Scheduling &amp; Changes
            </h2>
            <ul className="mt-2 space-y-2 text-slate-300 list-disc pl-5">
              <li>
                Program details (duration, modules, outcomes) are described on
                the Website or shared at booking.
              </li>
              <li>
                We may reschedule sessions due to trainer availability,
                holidays, venue constraints, or force majeure. You’ll be
                notified via your registered contact details.
              </li>
              <li>
                Certificates (where applicable) are subject to full attendance
                and successful completion of required assessments.
              </li>
            </ul>
          </section>

          {/* 4 */}
          <section>
            <h2 className="text-xl font-bold text-white">
              4. Pricing, Payments &amp; Refunds
            </h2>
            <ul className="mt-2 space-y-2 text-slate-300 list-disc pl-5">
              <li>
                All prices are shown in INR unless stated otherwise. Taxes may
                apply.
              </li>
              <li>
                Fees must be paid in full (or per stated schedule) to confirm
                enrollment.
              </li>
              <li>
                <span className="font-semibold">Refunds:</span> Unless a
                specific program policy states otherwise:
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>
                    Full refund if you cancel within 48 hours of payment and ≥7
                    days before the program start.
                  </li>
                  <li>
                    50% refund if you cancel ≥72 hours before the start date.
                  </li>
                  <li>
                    No refund for cancellations within 72 hours of the start
                    date or after the program starts.
                  </li>
                </ul>
              </li>
              <li>
                If we cancel a program without offering an alternative slot, you
                will receive a full refund.
              </li>
            </ul>
          </section>

          {/* 5 */}
          <section>
            <h2 className="text-xl font-bold text-white">5. Acceptable Use</h2>
            <ul className="mt-2 space-y-2 text-slate-300 list-disc pl-5">
              <li>
                Do not misuse the Website (e.g., inject malware, scrape without
                permission, or attempt unauthorized access).
              </li>
              <li>
                Do not record, reproduce, distribute, or share training content
                without our written consent.
              </li>
              <li>
                Be respectful to trainers and participants; harassment or
                disruptive behavior may lead to removal without refund.
              </li>
            </ul>
          </section>

          {/* 6 */}
          <section>
            <h2 className="text-xl font-bold text-white">
              6. Intellectual Property
            </h2>
            <p className="mt-2 text-slate-300">
              All content on the Website and in our programs (including text,
              slides, videos, graphics, logos, and trademarks) is owned by OGCS
              Private Limited or its licensors and is protected by applicable IP
              laws. You receive a limited, non-transferable license to access
              materials for your personal learning. Any other use requires prior
              written permission.
            </p>
          </section>

          {/* 7 */}
          <section>
            <h2 className="text-xl font-bold text-white">
              7. Testimonials &amp; Media
            </h2>
            <p className="mt-2 text-slate-300">
              With your consent, we may publish your testimonials, reviews,
              photos, or videos from sessions for marketing purposes. You can
              withdraw consent anytime by contacting{" "}
              <a
                href="mailto:support@ogcs.co.in"
                className="text-sky-300 hover:text-white underline underline-offset-4"
              >
                support@ogcs.co.in
              </a>
              .
            </p>
          </section>

          {/* 8 */}
          <section>
            <h2 className="text-xl font-bold text-white">
              8. Third-Party Links
            </h2>
            <p className="mt-2 text-slate-300">
              The Website may contain links to third-party sites. We are not
              responsible for their content, policies, or practices. Access them
              at your own discretion.
            </p>
          </section>

          {/* 9 */}
          <section>
            <h2 className="text-xl font-bold text-white">9. Privacy</h2>
            <p className="mt-2 text-slate-300">
              We process your personal data in accordance with our privacy
              practices. By using the Website or enrolling in a program, you
              consent to such processing. For privacy questions, write to{" "}
              <a
                href="mailto:support@ogcs.co.in"
                className="text-sky-300 hover:text-white underline underline-offset-4"
              >
                support@ogcs.co.in
              </a>
              .
            </p>
          </section>

          {/* 10 */}
          <section>
            <h2 className="text-xl font-bold text-white">10. Disclaimers</h2>
            <ul className="mt-2 space-y-2 text-slate-300 list-disc pl-5">
              <li>
                The Website and programs are provided on an “as is” and “as
                available” basis.
              </li>
              <li>
                We do not guarantee job placement or specific results; outcomes
                depend on individual effort and market conditions.
              </li>
              <li>
                We make reasonable efforts to keep information accurate but do
                not warrant completeness or error-free content.
              </li>
            </ul>
          </section>

          {/* 11 */}
          <section>
            <h2 className="text-xl font-bold text-white">
              11. Limitation of Liability
            </h2>
            <p className="mt-2 text-slate-300">
              To the fullest extent permitted by law, OGCS Private Limited is
              not liable for any indirect, incidental, special, consequential,
              or punitive damages, or loss of profits, data, or goodwill,
              arising from your use of the Website or programs.
            </p>
          </section>

          {/* 12 */}
          <section>
            <h2 className="text-xl font-bold text-white">12. Indemnity</h2>
            <p className="mt-2 text-slate-300">
              You agree to indemnify and hold harmless OGCS Private Limited, its
              directors, employees, and partners from any claims, damages,
              liabilities, and expenses arising from your misuse of the Website,
              breach of these Terms, or violation of rights of any third party.
            </p>
          </section>

          {/* 13 */}
          <section>
            <h2 className="text-xl font-bold text-white">
              13. Governing Law &amp; Dispute Resolution
            </h2>
            <p className="mt-2 text-slate-300">
              These Terms are governed by the laws of India. Courts in{" "}
              <span className="font-semibold">Mumbai, Maharashtra</span>
              shall have exclusive jurisdiction. Disputes will first be
              attempted to be resolved amicably; failing which, they shall be
              referred to a sole arbitrator in Mumbai under the Arbitration and
              Conciliation Act, 1996.
            </p>
          </section>

          {/* 14 */}
          <section>
            <h2 className="text-xl font-bold text-white">
              14. Changes to These Terms
            </h2>
            <p className="mt-2 text-slate-300">
              We may update these Terms from time to time. Changes are effective
              when posted on this page with the “Last updated” date. Continued
              use of the Website signifies your acceptance of the updated Terms.
            </p>
          </section>

         

          <p className="text-[12px] text-slate-400">
            <strong>Note:</strong> This document is provided for general
            informational purposes and does not constitute legal advice. Please
            consult your counsel to adapt it to your specific needs.
          </p>
        </div>
      </section>
    </main>
  );
}
